<template>
  <row12>
    <edit-multi-label-dialog @select_label_ids=select_label_ids @update_label="update_label" :labels="chipLabels" :selected_labels_ids="selected_labels_ids" @close_modal="close_modal" v-if="multi_edit_dialog"></edit-multi-label-dialog>
    <v-overlay
        :model-value="loading"
        class="align-center justify-center"
        persistent
    >
      <v-progress-circular
          indeterminate
          size="64"
      ></v-progress-circular>
    </v-overlay>
    <row v-if="show_select">
      <col12 style="text-align:right">
        <h4>{{$t('set_label_sets.selected_labels')}}
          <span v-if="selected_labels_ids.length > 0" id="selected_labels_count">({{ selected_labels_ids.length }})</span>
        </h4>
        <v-chip v-for="label in displayed_selected_labels" :key="label.id" close @click:close="() => unselect_label(label.id)"
                :dark="true" small
                :style="{ 'font-weight': 'bold', 'background-color': `rgba(${label.color})` }">
          {{ label.name }}
        </v-chip>
        <v-chip
          v-if="hidden_selected_count > 0"
          id="selected_labels_more"
          small
          class="selected-labels-more"
        >
          {{ $t('set_label_sets.selected_labels_more', { n: hidden_selected_count }) }}
        </v-chip>
      </col12>
    </row>

    <div>
      <v-btn small color="primary" @click="viewmodus='tree'" :disabled="treeDisabled">
        <v-icon x-small>
          fas fa-sitemap
        </v-icon>
        <span style="padding-left: 10px;">{{$t('set_labels.tree_view')}}</span>
      </v-btn>
      <v-btn small color="primary" @click="viewmodus='list'">
        <v-icon x-small>
          fas fa-th-list
        </v-icon>
        <span style="padding-left: 10px;">{{$t('set_labels.list_view')}}</span>
      </v-btn>
      <span v-if="treeDisabled" id="labels_tree_disabled_hint" class="tree-disabled-hint">
        {{ $t('set_labels.tree_view_disabled_large') }}
      </span>
    </div>
    <my-boxes-modal :label_name="boxes_modal_label_name" v-if="show_boxes_modal" @close_modal="close_preview_label_in_modal"></my-boxes-modal>
    <list-view
      ref="listView"
      v-if="viewmodus==='list'"
      :show_select="true"
      :selected_labels_ids="selected_labels_ids"
      @select_label_ids="select_label_ids"
      @unselect_label="unselect_label"
      @update_label="update_label"
      @preview_label="preview_label_in_modal"
      @page_loaded="onPageLoaded"
      :menu_items_on_select="menu_items_on_select"
    ></list-view>
    <tree-view v-if="viewmodus==='tree' && !treeDisabled"
               :show_select="show_select" :labels="storeLabels"
               :selected_labels_ids="selected_labels_ids"
               @unselect_label="unselect_label"
               @select_label_ids="select_label_ids"
               @preview_label="preview_label_in_modal"
               ></tree-view>
  </row12>
</template>

<script>
import Row12 from "@/components/layout/Row12";
import ListView from "@/components/manage_labels/ListView";
import TreeView from "@/components/manage_labels/TreeView";
import MyBoxesModal from "@/components/MyBoxesModal";
import Row from "@/components/layout/Row.vue";
import Col12 from "@/components/layout/Col12.vue";
import EditMultiLabelDialog from "@/components/manage_labels/EditMultiLabelDialog.vue";
import { FULL_CATALOG_MAX_LABELS } from "@/store/modules/label/actions.js";

const SELECTED_CHIPS_PREVIEW = 12;

export default {
  name: "LabelList",
  data() {
    return {
      'viewmodus': 'list',
      'show_boxes_modal': false,
      'boxes_modal_label_name': false,
      'multi_edit_dialog': false,
      'chipLabels': [],
      'pageTotal': 0,
    }
  },
  props: {
    selected_labels_ids: {default: () => []},
    show_select: {default: false},
  },
  methods: {
    close_modal() {
      this.multi_edit_dialog = false
    },
    open_multi_edit_modal() {
      this.multi_edit_dialog = true
    },
    select_label_ids (ids) {
      this.$emit('select_label_ids', ids)
    },
    unselect_label(label_id) {
      let updated_selected_label_ids = this.selected_labels_ids.filter(id => id != label_id);
      this.$emit('select_label_ids', updated_selected_label_ids)
    },
    preview_label_in_modal(label_name) {
      this.show_boxes_modal = true;
      this.boxes_modal_label_name = label_name;
    },
    close_preview_label_in_modal() {
      this.show_boxes_modal = false;
      this.boxes_modal_label_name = null;
    },
    update_label(label) {
      this.$store.dispatch('label/patch', { item: label, dispatch: this.$store.dispatch })
      if (this.$refs.listView && this.$refs.listView.reload) {
        this.$refs.listView.reload();
      }
    },
    onPageLoaded({ total }) {
      this.pageTotal = total || 0;
      if (this.treeDisabled && this.viewmodus === 'tree') {
        this.viewmodus = 'list';
      }
    },
    async refreshSelectedChips() {
      const ids = this.selected_labels_ids || [];
      if (!ids.length) {
        this.chipLabels = [];
        return;
      }
      const previewIds = ids.slice(0, SELECTED_CHIPS_PREVIEW);
      const fromStore = (this.storeLabels || []).filter((l) => previewIds.includes(l.id));
      const missing = previewIds.filter((id) => !fromStore.some((l) => l.id === id));
      let fetched = [];
      if (missing.length) {
        fetched = (await this.$api.label.fetchByIds(missing)) || [];
      }
      const byId = new Map([...fromStore, ...fetched].map((l) => [l.id, l]));
      this.chipLabels = previewIds.map((id) => byId.get(id)).filter(Boolean);
    },
    reloadList() {
      if (this.$refs.listView && this.$refs.listView.reload) {
        return this.$refs.listView.reload();
      }
    },
  },
  computed: {
    storeLabels() {
      return this.$store.getters['label/get_items'] || [];
    },
    displayed_selected_labels() {
      return this.chipLabels;
    },
    hidden_selected_count() {
      return Math.max(0, (this.selected_labels_ids || []).length - SELECTED_CHIPS_PREVIEW);
    },
    menu_items_on_select() {
      return [
        {'title': this.$t('set_labels.edit_selected_labels'), 'on_click': this.open_multi_edit_modal},
      ]
    },
    loading() {
      return this.$store.getters['label/get_loading'];
    },
    treeDisabled() {
      const total = this.pageTotal || this.$store.getters['label/get_total_count'] || 0;
      return total > FULL_CATALOG_MAX_LABELS;
    },
  },
  watch: {
    selected_labels_ids: {
      handler() {
        this.refreshSelectedChips();
      },
      immediate: true,
    },
    treeDisabled(disabled) {
      if (disabled && this.viewmodus === 'tree') {
        this.viewmodus = 'list';
      }
    },
  },
  mounted () {
    // Warm small catalogs in the background; large projects stay on API search + server table.
    this.$store.dispatch('label/prefetch_all_background');
  },
  components: {EditMultiLabelDialog, Col12, Row, MyBoxesModal, TreeView, ListView, Row12},
}
</script>

<style scoped>
.selected-labels-more {
  font-weight: bold;
}
.tree-disabled-hint {
  margin-left: 12px;
  color: #666;
  font-size: 0.9em;
}
</style>
